import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-131fadef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid my_messages" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header d-none" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, " Need: Improve Treatment Support For TB Patients "),
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, " Video Treatment Support (VOT) for TB Patients Via Mobiles ")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "container-lg container-fluid my_messages"
}
const _hoisted_4 = { class: "row d-flex h-100 align-items-center" }
const _hoisted_5 = { class: "col-lg-5" }
const _hoisted_6 = { class: "col-lg-7" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "d-flex my-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Inbox", -1))
const _hoisted_10 = { class: "count" }
const _hoisted_11 = { class: "message_wrapper row" }
const _hoisted_12 = { class: "partner_list col-lg-3 mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Partners", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "col-lg-8" }
const _hoisted_18 = { class: "message_list" }
const _hoisted_19 = { class: "header shadow-sm" }
const _hoisted_20 = { class: "text-primary mb-0" }
const _hoisted_21 = {
  key: 0,
  class: "px-2"
}
const _hoisted_22 = {
  key: 0,
  class: "row justify-content-start px-0"
}
const _hoisted_23 = { class: "col-lg-6 mb-3" }
const _hoisted_24 = { class: "card card-body content" }
const _hoisted_25 = { class: "details" }
const _hoisted_26 = {
  key: 1,
  class: "row justify-content-end px-0"
}
const _hoisted_27 = { class: "col-lg-6 mb-3" }
const _hoisted_28 = { class: "card card-body content alternate" }
const _hoisted_29 = { class: "details" }
const _hoisted_30 = {
  key: 1,
  class: "empty_state"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "scrollTo" }, null, -1))
const _hoisted_33 = {
  key: 0,
  class: "comment_section"
}
const _hoisted_34 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubBar = _resolveComponent("SubBar")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_SubBar),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createVNode(_component_Skeleton, {
            width: "100%",
            style: {"height":"6rem"},
            class: "mb-4"
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"15rem"},
                class: "mb-2"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"15rem"}
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"10rem"},
                class: "mb-3"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"10rem"},
                class: "mb-3"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                style: {"height":"4rem"},
                class: "mb-3"
              })
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.data.comments?.length || 3) + " new", 1)
          ]),
          _createElementVNode("section", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPartnerByInnovationId, (el, i) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: i,
                  class: "pointer-cursor"
                }, [
                  _createElementVNode("li", {
                    class: _normalizeClass([[_ctx.currentPartner?.id === el?.id ? 'active' : ''], "p-2"]),
                    onClick: _withModifiers(($event: any) => (_ctx.onPartnerClick(el)), ["prevent"])
                  }, [
                    (el?.profile_picture)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.getUserImage(el?.profile_picture),
                          alt: el?.username,
                          width: "30",
                          height: "30",
                          class: "rounded-circle"
                        }, null, 8, _hoisted_16))
                      : (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 1,
                          width: "30px",
                          style: {"height":"30px"},
                          class: "rounded-circle"
                        })),
                    _createTextVNode(" "),
                    _createElementVNode("span", null, _toDisplayString(el?.first_name) + " " + _toDisplayString(el?.last_name), 1)
                  ], 10, _hoisted_15)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.currentPartnerTitle), 1)
                ]),
                (_ctx.messages?.length > 0)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (el, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          (el.sent_by === 'INNOVATOR')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("p", null, _toDisplayString(el.message), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("small", null, _toDisplayString(_ctx.innovator?.first_name) + " " + _toDisplayString(_ctx.innovator?.last_name) + ", Innovator", 1),
                                    _createElementVNode("small", null, _toDisplayString(_ctx.formatDate(el.created_at)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (el.sent_by === 'PARTNER')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("p", null, _toDisplayString(el.message), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("small", null, _toDisplayString(_ctx.currentPartner?.first_name) + " " + _toDisplayString(_ctx.currentPartner?.last_name) + ", Partner", 1),
                                    _createElementVNode("small", null, _toDisplayString(_ctx.formatDate(el.created_at)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_30, [
                      _createElementVNode("img", {
                        src: require('../../../../assets/png/status_update.png'),
                        alt: "",
                        width: "300"
                      }, null, 8, _hoisted_31)
                    ])),
                _hoisted_32
              ]),
              (_ctx.currentPartner?.email?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("form", {
                      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createMileStoneComment && _ctx.createMileStoneComment(...args)), ["prevent"]))
                    }, [
                      _createVNode(_component_Textarea, {
                        modelValue: _ctx.comment,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
                        id: "comment",
                        name: "comment",
                        autoResize: false,
                        rows: "3",
                        cols: "30",
                        placeholder: "Enter text here ...",
                        class: "w-100",
                        required: ""
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_Button, {
                          type: "submit",
                          icon: "pi pi-arrow-right-arrow-left",
                          class: "p-button-raised p-button-text px-lg-5 px-3",
                          disabled: _ctx.loadingComments || _ctx.comment.length <= 0,
                          onClick: _withModifiers(_ctx.createMileStoneComment, ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass([
                      _ctx.loadingComments ? 'pi pi-spin pi-spinner px-2' : '',
                    ])
                            }, null, 2),
                            _createTextVNode(" Submit")
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ])
                    ], 32)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
  ]))
}